import { render, staticRenderFns } from "./MentorshipCallToActionMessage.vue?vue&type=template&id=4a5b8432&scoped=true&"
import script from "./MentorshipCallToActionMessage.vue?vue&type=script&lang=js&"
export * from "./MentorshipCallToActionMessage.vue?vue&type=script&lang=js&"
import style0 from "./MentorshipCallToActionMessage.vue?vue&type=style&index=0&id=4a5b8432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b8432",
  null
  
)

export default component.exports